import React from 'react'
import { useTheme } from '@mui/material/styles';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { useStyles } from './FormikPasswordInput.styles';
import { PasswordInputType } from './PasswordInputType';
import { ThemeProps } from '@styles/theme';

type VisibilityTogglePrefixProps = {
    type: PasswordInputType;
    setType: (type: PasswordInputType) => void;
    value: string;
}

export const VisibilityTogglePrefix: React.FC<VisibilityTogglePrefixProps> = ({
    type, setType, value,
}) => {
    const theme = useTheme<ThemeProps>();

    const styles = useStyles({ theme });

    const updateType = () => setType(
        type === PasswordInputType.PASSWORD
            ? PasswordInputType.TEXT
            : PasswordInputType.PASSWORD
    );

    return (
        value ? (
            <div
                className={styles.toggle}
                onClick={updateType}
                data-testid="visibility-toggle-button"
            >
                {
                    type === PasswordInputType.PASSWORD
                        ? <VisibilityOutlinedIcon />
                        : <VisibilityOffOutlinedIcon />
                }
            </div>
        ) : null
    )
}
